import type { Template } from './api'
import { bytes } from './format'

/**
 * A saved template's documents, pages and size, all of its documents
 * together. The first document's alone described a pack of two by half of
 * it. A server older than the totals is read as one document.
 */
export function templateSize(t: Template): string {
  const documents = t.document_count ?? 1
  const pages = t.total_page_count ?? t.page_count
  const parts = [`${pages} page${pages === 1 ? '' : 's'}`, bytes(t.total_document_bytes ?? t.document_bytes)]
  if (documents > 1) parts.unshift(`${documents} documents`)
  return parts.join(' · ')
}

/**
 * The lead on both template sends. A saved template can hold several
 * documents, and the lead said "The document and its 1 box" for a template of
 * three (D9). A Library entry is one document. A rule file rather than the
 * page, so the app runs it in place (review-2-app R2).
 */
export function alreadySet(documents: number, boxes: number): string {
  const theBoxes = `${boxes} box${boxes === 1 ? '' : 'es'}`
  return documents > 1
    ? `The ${documents} documents and their ${theBoxes} are already set.`
    : `The document and its ${theBoxes} are already set.`
}
